import { render, staticRenderFns } from "./IngresoNew.vue?vue&type=template&id=7c0ada75&scoped=true&"
import script from "./IngresoNew.vue?vue&type=script&lang=ts&"
export * from "./IngresoNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0ada75",
  null
  
)

export default component.exports